import ManageCustomerUsersModal from '@/pages/msps/customers/ManageCustomerUsersModal';
import { useCompany } from '@/services/api/hooks/companies';
import { Role, RoleType, useUser } from '@/services/authentication/hooks/user';
import { Navigate } from 'react-router-dom';
import { Button } from '../../components/form/Button';
import { ButtonVariant } from '../../components/form/buttonHelper';
import { useModal } from '../../components/modal/useModal';
import { NavigationMenu, NavigationMenuItem, NavigationMenuList } from './NavigationMenu';

const getMyDefaultLink = (user: Role) => {
  if (user.type === RoleType.Admin) {
    return '/msps/manageMsps';
  }
  if (user.type === RoleType.Partner) {
    return `/msps/${user.partnerId}/companies`;
  }
  if (user.type === RoleType.Company) {
    return `/msps/${user.partnerId}/companies/${user.customerId}/catalogue`;
  }
  if (user.type === RoleType.CreditChecker) {
    return `/creditcheck`;
  }
  throw new Error('Invalid user type');
};

export const Default = () => {
  const { role } = useUser();
  const link = getMyDefaultLink(role);

  return <Navigate to={link} />;
};

const CompanyNavItems = () => {
  const { role, id } = useUser();
  const [company] = useCompany(role.partnerId!, role.customerId!);

  const canManageUsers = !company.disabled && company.signatoryId === id;

  const manageUsersModalProps = useModal<{ mspId: string; customerId: string; asCustomer: boolean }>();
  const onCustomerManageUsers = () =>
    manageUsersModalProps.open({ mspId: role.partnerId!, customerId: role.customerId!, asCustomer: true });

  return (
    <>
      {canManageUsers && (
        <>
          <ManageCustomerUsersModal {...manageUsersModalProps} />
          <NavigationMenuItem>
            <Button variant={ButtonVariant.Ghost} onClick={onCustomerManageUsers}>
              <span>Authorised Agents</span>
            </Button>
          </NavigationMenuItem>
        </>
      )}
    </>
  );
};

export function HeaderNavigation() {
  const { role } = useUser();

  return (
    <NavigationMenu>
      <NavigationMenuList>{role.type === RoleType.Company && <CompanyNavItems />}</NavigationMenuList>
    </NavigationMenu>
  );
}
